import { CartUpsellingToolInput, Package } from "./types";

const sunRule = (p: Package) =>
  p.lensPackage?.color &&
  p.lensPackage.colorCategory &&
  !p.lensPackage.blueLight &&
  !p.lensPackage.transition;

export function getImagery(
  suggestion: Package,
  input: {
    _content: CartUpsellingToolInput["_content"];
    _locale: CartUpsellingToolInput["_locale"];
    _packages: CartUpsellingToolInput["_packages"];
    _currentPackage: CartUpsellingToolInput["_currentPackage"];
    _imagery: CartUpsellingToolInput["_imagery"];
  },
) {
  const selected = input._packages.find(
    (p) => p?.lensPackage?.catEntryId === input._currentPackage,
  );
  let productImage = input._imagery?.productImage;

  if (
    sunRule(suggestion) &&
    suggestion.lensPackage.brand !== selected?.lensPackage.brand
  ) {
    productImage = input._imagery.productImage.replace(
      "CompositeNoLogo",
      "CompositeLogo",
    );
  }
  return {
    productImage: productImage,
    fallbackImage: input._imagery?.fallbackImage,
  };
}
